import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const EtUserActionPerformanceCollectiveChart = ({
  performanceSnapshot,
  action,
  loggedInUserId,
}) => {
  
  // First Created: 06 Jan 2026
  // Author: Atul Pandey
  // Purpose: Display Collective Performance distribution for a User Action

  // ------------------------------------------------------------
  // 1️⃣ Normalize chart data
  // ------------------------------------------------------------
  const chartData = useMemo(() => {
    return performanceSnapshot.contributors.map((c) => ({
      userId: c.userId,
      name:
        c.userId === loggedInUserId
          ? `${c.userName} (Me)`
          : c.userName,
      actualValue: c.actualValue ?? 0,
      percentOfTarget: c.percentOfTarget ?? 0,
    }));
  }, [performanceSnapshot, loggedInUserId]);

  // ------------------------------------------------------------
  //  2️⃣ Guardrails
  // ------------------------------------------------------------
  if (!performanceSnapshot || !performanceSnapshot.contributors?.length) {
    return (
      <p className="text-xs text-gray-500 italic">
        No collective performance data available.
      </p>
    );
  }

  // ------------------------------------------------------------
  // 3️⃣ Render
  // ------------------------------------------------------------
  return (
    <div className="mt-4 space-y-4">
      {/* ----------------------------------
          Summary Context (keep lightweight)
         ---------------------------------- */}
      <div className="flex items-center gap-4 text-xs text-gray-700">
        <span>
          Achieved:{" "}
          <strong>{performanceSnapshot.achievedValue}</strong>{" "}
          {performanceSnapshot.uom}
        </span>
        <span>
          Target:{" "}
          <strong>{performanceSnapshot.targetValue}</strong>{" "}
          {performanceSnapshot.uom}
        </span>
        <span>
          Progress:{" "}
          <strong>{performanceSnapshot.progressPercent}%</strong>
        </span>
      </div>

      {/* ----------------------------------
          Collective Contribution Chart
         ---------------------------------- */}
      <div className="h-[240px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 10, right: 20, left: 40, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              type="number"
              tick={{ fontSize: 10 }}
              domain={[0, "dataMax"]}
            />
            <YAxis
              type="category"
              dataKey="name"
              tick={{ fontSize: 10 }}
              width={120}
            />
            <Tooltip
              formatter={(value) =>
                `${value} ${performanceSnapshot.uom}`
              }
            />
            <Bar
              dataKey="actualValue"
              radius={[0, 6, 6, 0]}
              fill="#fb923c" // Trinity orange
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EtUserActionPerformanceCollectiveChart;